import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import axios from '../../../../services/AxiosInstance';
import swal from "sweetalert";
import { useForm } from "react-hook-form";


const CreateRate = (props) =>{
    //const userdetails = JSON.parse(localStorage.getItem('userDetails'));
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    let history = useHistory();
    const onSubmit = (data) => {
        console.log(data);
        //axios.defaults.headers.common['Authorization'] = `Bearer ${userdetails.idToken}`;
        //axios.defaults.headers.post['Content-Type'] = 'application/json';
        axios.post(`/api/auth/add-rate`, data)
        .then(res => {
            if (res.status === 200){
                swal("Rates added successfully", "success");
                history.push("/rate-master");
            }else{
                Promise.reject()
            }
        })
        .catch(err => {
            console.log( err.message);
            swal("Something went wrong", "error");
        });
        
    };
    return(
        <Fragment>
            <PageTitle activeMenu="Add Rate" motherMenu="Users" />
            <div className="row">
                <div className="col-xl-6 col-lg-12">
                    <div className="card">
                        <div className="card-header">
                        <h4 className="card-title">Add Rates</h4>
                        </div>
                        <div className="card-body">
                        <div className="basic-form">
                            <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="mb-3 row">
                                <label className="col-sm-12 col-form-label">Product Name</label>
                                <div className="col-sm-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Product Name"
                                    {...register("name", { required: true })}
                                />
                                {errors.name?.type === 'required' && "Product name is required"}
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-sm-12 col-form-label">Bid</label>
                                <div className="col-sm-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Bid Price"
                                    {...register("bid", { required: true })}
                                />
                                {errors.bid?.type === 'required' && "Bid Price is required"}
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-sm-12 col-form-label">Bid - H</label>
                                <div className="col-sm-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Bid-H Price"
                                    {...register("bidh", { required: true })}
                                />
                                {errors.bidh?.type === 'required' && "Bid - H Price is required"}
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-sm-12 col-form-label">Ask</label>
                                <div className="col-sm-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Ask Price"
                                    {...register("ask", { required: true })}
                                />
                                {errors.ask?.type === 'required' && "Ask Price is required"}
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-sm-12 col-form-label">Ask - L</label>
                                <div className="col-sm-12">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Ask - L Price"
                                    {...register("askl", { required: true })}
                                />
                                {errors.askl?.type === 'required' && "Ask - L Price is required"}
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <label className="col-sm-12 col-form-label">State</label>
                                <div className="col-sm-12">
                                <select 
                                    class="form-select" 
                                    {...register("state_id", { required: true })}
                                    >
                                    <option selected>Select State</option>
                                    <option value="24">Gujarat</option>
                                    <option value="37">Andhra Pradesh</option>
                                    <option value="07">Delhi</option>
                                    <option value="13">Karala</option>
                                    <option value="29">Karnataka</option>
                                    <option value="23">Madhya Pradesh</option>
                                    <option value="08">Rajasthan</option>
                                    <option value="33">Tamil Nadu</option>
                                    <option value="36">Telangana</option>
                                </select>
                                {errors.state_id?.type === 'required' && "State is required"}
                                </div>
                            </div>
                            <div className="mb-3 row">
                                <div className="col-sm-12">
                                    <button type="submit" className="btn btn-primary float-end">
                                        Submit
                                    </button>
                                </div>
                            </div>
                            </form>
                        </div>
                        </div>
                    </div>
                </div>          
            </div>
        </Fragment>
    )
}

export default CreateRate;